import { render, staticRenderFns } from "./RedNum.vue?vue&type=template&id=579c67ec"
import script from "./RedNum.vue?vue&type=script&lang=js"
export * from "./RedNum.vue?vue&type=script&lang=js"
import style0 from "./RedNum.vue?vue&type=style&index=0&id=579c67ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports